import React from "react";
import isEqual from "lodash/isEqual";
import submit from "submit-form";

import EditorWeekColumn from "./components/EditorWeekColumn";
import BackArrowButton from "../../../parts/back-arrow-button";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";
import SaveInputButtons from "../../../parts/SaveInputButtons";
import WeekConfiguration from "./components/WeekConfiguration";
import WorkoutConfiguration from "./components/WorkoutConfiguration";
import ClipboardContent from "../../../parts/ClipboardContent";
import AddWeekDropdown from "./components/AddWeekDropdown";

class View extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      exercises: props.exercises,
      localEditExercises: props.exercises,
      name: context.locals.program.name || "",
      description: context.locals.program.description || "",
      editingName: false,
      editingDescription: false,
      editingWorkouts: [],
      selectedWeeks: [],
      settingsOpened: false,
      configuration: false,
      nWeekSelected: 1,
      viewportWidth: null,
      isAddWeekOptionOpened: false,
    };
    this.checkChange = this.checkChange.bind(this);
    this.handleAddWeek = this.handleAddWeek.bind(this);
    this.handleAddWeekOptions = this.handleAddWeekOptions.bind(this);
    this.handleAddWeekOptionClick = this.handleAddWeekOptionClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateExercise = this.updateExercise.bind(this);
    this.updateExercises = this.updateExercises.bind(this);
    this.deleteExercise = this.deleteExercise.bind(this);
    this.updateOrderExercises = this.updateOrderExercises.bind(this);
    this.submitChange = this.submitChange.bind(this);
    this.workoutOpacityCallback = this.workoutOpacityCallback.bind(this);
    this.handleSelectWeek = this.handleSelectWeek.bind(this);
    this.handleDeleteWeeks = this.handleDeleteWeeks.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState(
      (prevState) =>
        Object.assign({}, prevState, {
          viewportWidth: window.innerWidth,
        }),
      this.handleDashboardPaddings
    );
  }

  componentDidMount() {
    this.setExerciseListHeight();

    !this.state.viewportWidth
      ? this.setState((prevState) =>
          Object.assign({}, prevState, {
            viewportWidth: window.innerWidth,
          })
        )
      : null;

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isEqual(this.context.locals.editExercises, prevState.localEditExercises)
    ) {
      this.setState({
        exercises: this.context.locals.editExercises,
        localEditExercises: this.context.locals.editExercises,
      });
    }

    this.setExerciseListHeight();
  }

  updateExercise(exercise) {
    const copyExercises = [...this.state.exercises];
    const exerciseIndex = copyExercises.findIndex(
      (elem) => elem._id === exercise._id
    );
    copyExercises[exerciseIndex] = exercise;
    this.setState({ exercises: copyExercises });
  }

  updateExercises(exercises) {
    const copyExercises = [...this.state.exercises];
    exercises.forEach((exercise) => {
      const exerciseIndex = copyExercises.findIndex(
        (elem) => elem._id === exercise._id
      );
      copyExercises[exerciseIndex] = exercise;
    });

    this.setState({ exercises: copyExercises });
  }

  updateOrderExercises(firstExercise, secondExercise) {
    const copyExercises = [...this.state.exercises];
    copyExercises.forEach((exercise, exerciseIndex) => {
      if (exercise._id === firstExercise._id) {
        copyExercises[exerciseIndex] = secondExercise;
      } else if (exercise._id === secondExercise._id) {
        copyExercises[exerciseIndex] = firstExercise;
      }
    });

    this.setState({ exercises: copyExercises });
  }

  deleteExercise(exerciseId) {
    const copyExercises = [...this.state.exercises];
    const exerciseIndex = copyExercises.findIndex(
      (elem) => elem._id === exerciseId
    );

    copyExercises.splice(exerciseIndex, 1);
    this.setState({ exercises: copyExercises });
  }

  /**
   * Function to add a single week (clicking the add week button)
   * @param {*} e
   * @param {*} isCoach
   * @param {*} numberOfWeeks
   * @param {*} sessionsPerWeek
   * @param {*} cycle
   * @param {*} programNumber
   * @param {*} isAddWeekOptionOpened
   */
  handleAddWeek(
    e,
    isCoach,
    numberOfWeeks,
    sessionsPerWeek,
    cycle,
    programNumber,
    isAddWeekOptionOpened
  ) {
    e.preventDefault();
    this.handleSubmitAddWeeks({
      isCoach,
      sessionsPerWeek,
      newWeeks: 1,
      cycle,
      programNumber,
      initNewWeek: numberOfWeeks,
      closeDropdown: isAddWeekOptionOpened,
    });
  }

  /**
   * Function to add multiple weeks (clicking a option from the add weeks list)
   * @param {*} e
   * @param {*} isCoach
   * @param {*} numberOfWeeks
   * @param {*} sessionsPerWeek
   * @param {*} cycle
   * @param {*} programNumber
   * @param {*} newWeeks
   */
  handleAddWeekOptionClick = (
    e,
    isCoach,
    numberOfWeeks,
    sessionsPerWeek,
    cycle,
    programNumber,
    newWeeks
  ) => {
    e.preventDefault();
    this.handleSubmitAddWeeks({
      isCoach,
      sessionsPerWeek,
      newWeeks,
      cycle,
      programNumber,
      initNewWeek: numberOfWeeks,
      closeDropdown: true,
    });
  };

  /**
   * Call the API request to add weeks
   * @param {*} param0
   */
  handleSubmitAddWeeks({
    isCoach,
    sessionsPerWeek,
    newWeeks,
    cycle,
    programNumber,
    initNewWeek,
    closeDropdown = false,
  }) {
    const proceed = () => {
      const weekLabel = newWeeks === 1 ? "a new week" : `${newWeeks} new weeks`;
      if (confirm(`Do you want to add ${weekLabel} to this program?`)) {
        const body = {
          cycle,
          program: programNumber,
          initNewWeek,
          newWeeks,
        };
        if (isCoach) {
          body.sessionsPerWeek = sessionsPerWeek;
        }
        submit(`/actions/cycle/program/addWeek`, {
          method: "POST",
          body,
        });
      }
    };

    if (closeDropdown) {
      this.setState({ isAddWeekOptionOpened: false }, proceed);
    } else {
      proceed();
    }
  }

  handleAddWeekOptions = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      const eventType = e.type;

      if (eventType === "mouseenter") {
        this.setState({ isAddWeekOptionOpened: true });
      } else if (eventType === "mouseleave") {
        this.setState({ isAddWeekOptionOpened: false });
      } else if (eventType === "click") {
        this.setState((prevState) => ({
          isAddWeekOptionOpened: !prevState.isAddWeekOptionOpened,
        }));
      }
    }
  };

  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    });
  }

  checkChange(type) {
    const {
      locals: { program },
    } = this.context;
    if (this.state[type] !== program[type]) return true;
    return false;
  }

  submitChange(body) {
    const activeUser =
      this.context.locals.athlete || this.context.locals.activeUser;
    const programNumber = this.context.locals.query.program;
    const cycleId = this.context.locals.params.cycleId;

    submit(
      `/actions/cycle/edit/program/${cycleId}?program=${programNumber}&athlete=${activeUser}`,
      {
        method: "POST",
        body,
      }
    );
  }

  workoutOpacityCallback({ type = "add", keyId = "" }) {
    const result =
      type === "add"
        ? [...this.state.editingWorkouts, keyId]
        : this.state.editingWorkouts.filter((workout) => workout !== keyId);
    this.setState({
      editingWorkouts: result,
    });
  }

  setExerciseListHeight() {
    for (let n = 0; n < 7; n++) {
      const className = `workout-${n + 1}-list`;
      // gets one row of workouts
      const elements = Array.from(document.getElementsByClassName(className));

      elements.forEach((el) => {
        el.style.height = "auto";
      });
      const elementsHeights = elements.map((el) => el.clientHeight);
      const maxHeight = Math.max(...elementsHeights);
      // set the height of all elements in the row to the same height as the tallest element in it
      elements.forEach((el) => {
        el.style.height = `${maxHeight}px`;
      });
    }
  }

  handleSelectWeek(week) {
    this.setState((prevState) => {
      if (prevState.selectedWeeks.includes(week)) {
        return {
          ...prevState,
          selectedWeeks: prevState.selectedWeeks.filter(
            (_week) => _week !== week
          ),
        };
      } else {
        return {
          ...prevState,
          selectedWeeks: [...prevState.selectedWeeks, week],
        };
      }
    });
  }

  handleDeleteWeeks(e) {
    e.preventDefault();
    const { selectedWeeks } = this.state;
    const { editCycle, query } = this.context.locals;
    if (
      !selectedWeeks?.length ||
      !confirm(`Are you sure you want to delete ${selectedWeeks.length} weeks?`)
    ) {
      return;
    }
    this.setState({ selectedWeeks: [] });
    submit("/actions/cycle/program/delete-weeks", {
      method: "POST",
      body: {
        cycle: editCycle._id,
        program: query.program,
        selectedWeeks,
      },
    });
  }

  handleDismiss(e, type, key) {
    e.preventDefault();
    const initialValue = this.context.locals.program[key];
    this.setState({ [type]: false, [key]: initialValue });
  }

  render() {
    const { locals } = this.context;
    const { editingName, editingDescription, settingsOpened, configuration } =
      this.state;
    // locals.athlete is preloaded in the ensureCoach middleware
    const activeUser = locals.athlete || locals.activeUser;
    const activeUserToRequest = locals.activeUserToRequest;
    const programNumber = locals.query.program;
    const exercisesInClipboard = locals.query.exercisesInClipboard;
    const cycleId = locals.params.cycleId;
    // Fixes MSB-947
    const scrollTo = locals.query.scrollTo;

    //Group sessions into weeks
    const weeks = locals.weeks;
    const numberOfWeeks = Object.keys(weeks).length;
    const remainingWeeks = Array.from(
      { length: Math.max(12 - numberOfWeeks, 0) },
      (_, i) => {
        const count = i + 1;
        return {
          text: `Add ${count} Week${count > 1 ? "s" : ""}`,
          value: count,
        };
      }
    );

    // Ensure the activeWeek param is within the available weeks
    if (locals.activeWeek > numberOfWeeks - 1)
      locals.activeWeek = numberOfWeeks;
    if (locals.activeWeek < 1) locals.activeWeek = 1;

    const isCoach = locals.editCycle.type !== "user";
    const sessionsPerWeek = weeks["1"].length;

    // Check if inside athlete-portal for showing the RM's athlete at the top
    const isAthletePortal = locals.pathname.startsWith("/athlete-portal/");
    let newSquat, newBench, newDeadlift, athleteName;
    if (isAthletePortal) {
      athleteName = locals.athlete.name;
      // RMs of current athlete
      const { squat, bench, deadlift } = locals.athlete.repMaximums;

      newSquat = locals.fromMetric(squat);
      newBench = locals.fromMetric(bench);
      newDeadlift = locals.fromMetric(deadlift);
    }

    const unit = locals.activeUser.units === "imperial" ? "lb" : "kg";
    const isTemplatesPage =
      locals.pathname.indexOf("/templates/") === -1 ? false : true;
    const storeType = locals.editCycle.storeType || "programs";

    const handleReturnButton = (athleteId) => {
      if (athleteId) {
        let body = { athlete: athleteId };

        if (locals.query.organizationCoach) {
          body = { ...body, organizationCoach: locals.query.organizationCoach };
        }

        submit(`/athlete-portal/programs/`, {
          method: "GET",
          body,
        });
      } else if (locals.pathname.includes("store")) {
        submit(`/coaching-portal/store`, {
          method: "GET",
          body: { status: "draft", storeType: storeType },
        });
      } else {
        submit(`/coaching-portal/all-templates`, {
          method: "GET",
          body: { owner: "coach" },
        });
      }
    };

    const selectedWeeksLength = this.state.selectedWeeks?.length;
    const nameDisabled = !this.checkChange("name");
    const descriptionDisabled = !this.checkChange("description");

    const notSingleWorkout = storeType !== "single-workout";

    return (
      <main className="Program-Editor program-builder">
        <header>
          <hgroup className={`${notSingleWorkout ? "" : "items-center"}`}>
            <BackArrowButton
              onBack={() => handleReturnButton(locals?.athlete?._id)}
            />

            {!notSingleWorkout && <p>{locals.editCycle.name}</p>}

            {notSingleWorkout && (
              <div className="mobile-hidden">
                <div className="header-input">
                  <label htmlFor="name">Block name</label>

                  <input
                    type="text"
                    id="name"
                    name="name"
                    className={editingName ? "editing" : ""}
                    value={this.state.name}
                    onChange={this.handleChange}
                    onFocus={() => this.setState({ editingName: true })}
                  />
                  <SaveInputButtons
                    enabled={editingName}
                    handleSave={(e) => {
                      e.preventDefault();
                      this.submitChange({ name: this.state.name });
                      this.setState({ editingName: false });
                    }}
                    handleDismiss={(e) =>
                      this.handleDismiss(e, "editingName", "name")
                    }
                    saveDisabled={nameDisabled}
                  />
                </div>

                <div className="header-input">
                  <label htmlFor="description">Block description</label>

                  <input
                    type="text"
                    id="description"
                    name="description"
                    className={editingDescription ? "editing" : ""}
                    value={this.state.description}
                    onChange={this.handleChange}
                    onFocus={() => this.setState({ editingDescription: true })}
                  />
                  <SaveInputButtons
                    enabled={editingDescription}
                    handleSave={(e) => {
                      e.preventDefault();
                      this.submitChange({
                        description: this.state.description,
                      });
                      this.setState({ editingDescription: false });
                    }}
                    handleDismiss={(e) =>
                      this.handleDismiss(e, "editingDescription", "description")
                    }
                    saveDisabled={descriptionDisabled}
                  />
                </div>
              </div>
            )}

            {notSingleWorkout && (
              <div className="only-show-mobile">
                <span>{this.state.name}</span>
                <span>{this.state.description}</span>
              </div>
            )}
            {isTemplatesPage && (
              <ToolTip
                id="template-tooltip"
                body={`This is a template and calculated loads/intensities are derived
              using the 1RMs set on the coaches personal account. These are
              for context purposes only and will be recalculated using the ${
                activeUser.referAsClients ? "client" : "athlete"
              }'s 1RM's when sent to their library`}
              >
                <span>?</span>
              </ToolTip>
            )}
            {isAthletePortal && (
              <div className="rm-details">
                <span>1RMs | </span>
                <span>
                  <b>Squat</b> {`${newSquat} ${unit}`}
                </span>
                <span>
                  <b>Bench</b> {`${newBench} ${unit}`}
                </span>
                <span>
                  <b>Deadlift</b> {`${newDeadlift} ${unit}`}
                </span>
              </div>
            )}
          </hgroup>

          <hgroup>
            {selectedWeeksLength ? (
              <>
                <button
                  data-button-type="secondary"
                  onClick={() => this.setState({ selectedWeeks: [] })}
                >
                  Cancel
                </button>
                <button
                  data-button-type="secondary"
                  className="!text-[--danger]"
                  onClick={this.handleDeleteWeeks}
                >
                  <SvgIcon
                    classNames="mr-2"
                    src={"/img/new-icons/red-trash.svg"}
                    noFilterOnLight={true}
                  />
                  Delete {selectedWeeksLength}{" "}
                  {selectedWeeksLength > 1 ? "weeks" : "week"}
                </button>
              </>
            ) : (
              <>
                {numberOfWeeks < 12 && notSingleWorkout && (
                  <div
                    className="add-week-dropdown-wrapper"
                    onMouseLeave={this.handleAddWeekOptions}
                  >
                    <button
                      data-button-type="primary"
                      onClick={(e) =>
                        this.handleAddWeek(
                          e,
                          isCoach,
                          numberOfWeeks,
                          sessionsPerWeek,
                          locals.editCycle,
                          programNumber,
                          this.state.isAddWeekOptionOpened
                        )
                      }
                    >
                      <span>Add Week</span>
                      <SvgIcon
                        src={
                          this.state.isAddWeekOptionOpened
                            ? "/img/svg/angle-up.svg"
                            : "/img/svg/angle-down.svg"
                        }
                        noFilterOnLight={true}
                        onClickFn={this.handleAddWeekOptions}
                        onMouseEnterFn={this.handleAddWeekOptions}
                      />
                    </button>
                    {this.state.isAddWeekOptionOpened && (
                      <AddWeekDropdown
                        options={remainingWeeks}
                        handleAddWeekOptionClick={(e, value) =>
                          this.handleAddWeekOptionClick(
                            e,
                            isCoach,
                            numberOfWeeks,
                            sessionsPerWeek,
                            locals.editCycle,
                            programNumber,
                            value
                          )
                        }
                      />
                    )}
                  </div>
                )}

                <div>
                  <div className="only-show-mobile">
                    <ToolTip>
                      <a
                        data-button-type="secondary"
                        role="button"
                        href={`/actions/refresh/?modal[type]=progression&week=${this.state.nWeekSelected}&program=${programNumber}&cycle=${locals.editCycle._id}&type=week`}
                      >
                        <SvgIcon src="/img/new-icons/percentage-square.svg" />
                      </a>
                    </ToolTip>
                    <ToolTip>
                      <a
                        data-button-type="secondary"
                        role="button"
                        href={`/actions/refresh/?modal[type]=duplicate-week&week=${this.state.nWeekSelected}`}
                      >
                        <SvgIcon src="/img/new-icons/duplicate.svg" />
                      </a>
                    </ToolTip>

                    <ToolTip
                      id={`delete-week-${this.state.nWeekSelected.toString()}`}
                    >
                      <a
                        data-button-type="secondary"
                        role="button"
                        href={`/actions/cycle/delete-week/${locals.editCycle._id}/${programNumber}/${this.state.nWeekSelected}`}
                      >
                        <SvgIcon
                          src="/img/new-icons/red-trash.svg"
                          noFilterOnLight
                        />
                      </a>
                    </ToolTip>
                  </div>

                  <details role="list" open={settingsOpened}>
                    <summary
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.setState({ settingsOpened: !settingsOpened });
                      }}
                      onBlur={(e) => {
                        if (e.relatedTarget?.role === "listbox") return;
                        e.preventDefault();
                        this.setState({ settingsOpened: false });
                      }}
                      aria-haspopup="listbox"
                    >
                      <span>More</span>
                      <SvgIcon
                        src={
                          this.state.viewportWidth > 960
                            ? settingsOpened
                              ? "/img/svg/angle-up.svg"
                              : "/img/svg/angle-down.svg"
                            : "/img/new-icons/menu.svg"
                        }
                      />
                    </summary>
                    <ul
                      role="listbox"
                      className={settingsOpened ? "opened" : ""}
                    >
                      <div className="list-title">
                        <span>Settings</span>
                        <div />
                      </div>
                      <li
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          this.setState({ settingsOpened: false });
                          submit("/actions/refresh?", {
                            method: "GET",
                            body: {
                              "modal[type]": "program-settings",
                              storeType,
                            },
                          });
                        }}
                      >
                        <span>Edit Program Settings</span>
                        <SvgIcon src="/img/new-icons/export.svg" />
                      </li>
                      {notSingleWorkout && (
                        <>
                          <li
                            onMouseDown={(e) =>
                              this.setState({ configuration: "weeks" })
                            }
                          >
                            <span>Configure Weeks</span>
                            <SvgIcon src="/img/new-icons/settings.svg" />
                          </li>
                          <li
                            onMouseDown={(e) =>
                              this.setState({ configuration: "workouts" })
                            }
                          >
                            <span>Configure Workouts</span>
                            <SvgIcon src="/img/new-icons/settings.svg" />
                          </li>
                        </>
                      )}
                    </ul>
                  </details>
                </div>
              </>
            )}
          </hgroup>
        </header>

        <section className="Main">
          {this.state.viewportWidth > 960 && (
            <ul
              className={`weeks ${
                numberOfWeeks == locals.activeWeek ? "alt-last" : ""
              } mobile-hidden`}
            >
              {Array.from({ length: numberOfWeeks }, (_, i) => i + 1).map(
                (nWeek) => (
                  <EditorWeekColumn
                    key={`week_column_program_editor_${nWeek.toString()}`}
                    week={weeks[nWeek.toString()]}
                    exercises={this.state.exercises || []}
                    cycle={locals.editCycle}
                    program={locals.program}
                    programNumber={programNumber}
                    programOrder={locals.query.program}
                    activeWeek={locals.activeWeek}
                    column={nWeek.toString()}
                    fromMetric={locals.fromMetric}
                    activeUser={activeUser}
                    numberOfWeeks={numberOfWeeks}
                    scrollTo={scrollTo}
                    updateExercise={this.updateExercise}
                    deleteExercise={this.deleteExercise}
                    updateExercises={this.updateExercises}
                    updateOrderExercises={this.updateOrderExercises}
                    workoutOpacityCallback={this.workoutOpacityCallback}
                    editingWorkouts={this.state.editingWorkouts}
                    selectedWeeks={this.state.selectedWeeks}
                    handleSelectWeek={this.handleSelectWeek}
                  />
                )
              )}
            </ul>
          )}

          {this.state.viewportWidth <= 960 && (
            <>
              <div role="week-selector">
                <button
                  data-button-type="text-white"
                  data-icon-only="true"
                  onClick={() => {
                    this.state.nWeekSelected > 1 &&
                      this.setState({
                        nWeekSelected: this.state.nWeekSelected - 1,
                      });
                  }}
                >
                  <picture class="">
                    <img src="/img/new-icons/arrow-left.svg" />
                  </picture>
                </button>
                <span>Week {this.state.nWeekSelected}</span>
                <button
                  data-button-type="text-white"
                  data-icon-only="true"
                  onClick={() => {
                    this.state.nWeekSelected < numberOfWeeks &&
                      this.setState({
                        nWeekSelected: this.state.nWeekSelected + 1,
                      });
                  }}
                >
                  <picture class="">
                    <img src="/img/new-icons/arrow-right.svg" />
                  </picture>
                </button>
              </div>
              <ul
                className={`weeks ${
                  numberOfWeeks == locals.activeWeek ? "alt-last" : ""
                } only-show-mobile`}
              >
                <EditorWeekColumn
                  key={`week_column_program_editor_${this.state.nWeekSelected.toString()}`}
                  week={weeks[this.state.nWeekSelected.toString()]}
                  exercises={this.state.exercises || []}
                  cycle={locals.editCycle}
                  program={locals.program}
                  programNumber={programNumber}
                  programOrder={locals.query.program}
                  activeWeek={locals.activeWeek}
                  column={this.state.nWeekSelected.toString()}
                  fromMetric={locals.fromMetric}
                  activeUser={activeUser}
                  numberOfWeeks={numberOfWeeks}
                  scrollTo={scrollTo}
                  updateExercise={this.updateExercise}
                  deleteExercise={this.deleteExercise}
                  updateExercises={this.updateExercises}
                  updateOrderExercises={this.updateOrderExercises}
                  workoutOpacityCallback={this.workoutOpacityCallback}
                  editingWorkouts={this.state.editingWorkouts}
                  selectedWeeks={this.state.selectedWeeks}
                  handleSelectWeek={this.handleSelectWeek}
                />
              </ul>
            </>
          )}
        </section>

        {configuration == "weeks" && (
          <WeekConfiguration
            weeks={weeks}
            cycleId={cycleId}
            programNumber={programNumber}
            handleDiscard={() => this.setState({ configuration: false })}
          />
        )}
        {configuration == "workouts" && (
          <WorkoutConfiguration
            weeks={weeks}
            cycleId={cycleId}
            programNumber={programNumber}
            handleDiscard={() => this.setState({ configuration: false })}
          />
        )}
        {isCoach && (
          <ClipboardContent query={exercisesInClipboard} locals={locals} />
        )}
      </main>
    );
  }
}

export default View;
